import React from 'react';
import './Aboutus.css';
import image1 from '../Aboutus/images/nipun.png';
import image2 from '../Aboutus/images/pasindu.png';
import image3 from '../Aboutus/images/prabash.png';
import image4 from '../Aboutus/images/kavindu.png';
import image5 from '../Aboutus/images/prof.jpg';
import image6 from '../Aboutus/images/lec.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const AboutUs = () => {
  const teamMembers = [
    {
      name: "Nipun Sandeepa",
      position: "Member",
      bio: "Sri Lanka Institute of Information Technology - Malabe, Sri Lanka",
      imageSrc: image1,
      facebook: "https://www.facebook.com/M4DN3SK",
      linkedin: "https://www.linkedin.com/in/nipun-satharasingha-210629229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
      name: "Pasindu Perera",
      position: "Member",
      bio: "Sri Lanka Institute of Information Technology - Malabe, Sri Lanka",
      imageSrc: image2,
      facebook: "https://web.facebook.com/pasindu.manjitha.5",
      linkedin: "https://www.linkedin.com/in/pasindu-perera-120752221/"
    },
    {
      name: "Buddhima Prabashwara",
      position: "Member",
      bio: "Sri Lanka Institute of Information Technology - Malabe, Sri Lanka",
      imageSrc: image3,
      facebook: "https://www.facebook.com/profile.php?id=100006271248505",
      linkedin: "https://www.linkedin.com/in/buddhima-prabashwara-3ab754221?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
      name: "Kavindu Shehan",
      position: "Member",
      bio: "Sri Lanka Institute of Information Technology - Malabe, Sri Lanka",
      imageSrc: image4,
      facebook: "https://www.facebook.com/itzmekavii?mibextid=LQQJ4d",
      linkedin: "https://www.linkedin.com/in/kavindu-shehan/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
    },
    {
      name: "Sanath Jayawardhana",
      position: "Supervisor",
      bio: "Sri Lanka Institute of Information Technology - Malabe, Sri Lanka",
      imageSrc: image5,
      linkedin: "https://www.linkedin.com/in/sanath-siroshana-jayawardena-1507b244/"
    },
    {
      name: "Uditha Dharmakirthi",
      position: "Co-Supervisor",
      bio: "Sri Lanka Institute of Information Technology - Malabe, Sri Lanka",
      imageSrc: image6,
      linkedin: "https://www.linkedin.com/in/uditha-dharmakeerthi-84741b17/"
    }
  ];

  const Members = teamMembers.filter(member => member.position === "Member");
  const supervisors = teamMembers.filter(member => member.position !== "Member");

  return (
    <div className='about-us-container' id='aboutus'>
      <h1 className='about-us-heading'>
        About Us
      </h1>
      <div className='team-members'>
      <div className='supervisors' style={{width:"2000px"}}>
          {supervisors.map((member, index) => (
            <div key={index} className='member'>
              <h2>{member.position}</h2>
              <img src={member.imageSrc} alt={member.name} className='member-image' />
              <h3>{member.name}</h3>
              <p>{member.bio}</p>
              <div className="social-links">
  <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
    <FontAwesomeIcon icon={faLinkedin} className="icon" />
  </a>
</div>
            </div>
          ))}
        </div>
        <div className='Members'>
          {Members.map((member, index) => (
            <div key={index} className='member'>
              <h2>{member.position}</h2>
              <img src={member.imageSrc} alt={member.name} className='member-image' />
              <h3>{member.name}</h3>
              <p>{member.bio}</p>
              <div className="social-links">
  <a href={member.facebook} target="_blank" rel="noopener noreferrer">
    <FontAwesomeIcon icon={faFacebook} className="icon" />
  </a>
  <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
    <FontAwesomeIcon icon={faLinkedin} className="icon" />
  </a>
</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutUs;